import React, { Component } from "react";
import "./Simulation.css";
import Header from "./UISections/Header/Header";
import Footer from "./UISections/Footer/Footer";
import TestBreakPopup from "./Popups/TestBreakPopup/TestBreakPopup";
import FinishSectionPopup from "./Popups/FinishSectionPopup/FinishSectionPopup";
import OutOfTimePopup from "./Popups/OutOfTimePopup/OutOfTimePopup";
import ProcessingAudioPopup from "./Popups/ProcessingAudioPopup/ProcessingAudioPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import FetchingNextSectionPopup from "./Popups/FetchingNextSectionPopup/FetchingNextSectionPopup";
import axios from "axios";
import UploadingFilePopup from "./Popups/UploadingFilePopup/UploadingFilePopup";
import NewPdfViewer from "./Popups/NewPdfViewer/NewPdfViewer";
import ExitExamPopup from "./Popups/ExitExamPopup/ExitExamPopup";
import { AppContext } from "../../Util/contexts/AppContext";
import ContentInterfaceElement from "./SectionElements/ContentInterfaceElement";
import getAnswerSheet from "../../Util/functions/getAnswerSheet";
import TabNavigation from "./UISections/TabNavigation";
import SpeakingSection from "./SectionElements/Speaking_v2";

// Font-family for everything but body is open sans. Body is arial

export default class Simulation extends Component {
  constructor(props) {
    super(props);

    let sectionIndex = props.selectedExamSections.indexOf(
      props.firstExamSection.sectionId
    );
    
    this.state = {
      timerInSeconds: props.firstExamSection.sectionTimeInSeconds,
      tabSelected: 0,
      selectedAnswerIndex: null,
      textAnswer: "",
      onBreak: false,
      sectionData: props.firstExamSection,
      currentSection: sectionIndex,
      currentSectionId: props.firstExamSection.sectionId,
      currentTab: 0,
      displayFinishSectionPopup: false,
      displayRanOutOfTimePopup: false,
      userAnswers: props.initialAnswers,
      fetchedExamData: null,
      fetchingNextSection: false,
      displayPDFViewer: false,
      pdfDocked: false,
      pdfToDisplay: null,
      simulationWindowHeight: window.innerHeight,
      simulationBodyOverflowDetected: false,
      displayUploadingFilePopup: false,
      uploadProgress: 0,
      displayExitExamPopup: false,
      pdfViewerExpanded: false,
      selectedAccent:
        this.props.selectedAccent === "Random"
          ? this.getRandomAccent()
          : this.props.selectedAccent,
      isMobile: window.innerWidth <= 768,
    };
    this.appendSectionAnswersToAnswerSheet(
      props.firstExamSection,
      true,
      props.initialAnswers
    );
    this.toggleExpandPdfViewer = this.toggleExpandPdfViewer.bind(this);
  }

  static contextType = AppContext;

  sectionTimer = null;

  getRandomAccent = () => {
    let accents = ["British", "American", "Australian", "Irish"];
    return accents[Math.floor(Math.random() * accents.length)];
  };

  componentDidMount() {
    if (this.sectionTimer === null) this.startTimer();

    this.detectOverflowAndDisplayPopup();

    this.handleDisplayPdf(this.props.firstExamSection);

    window.addEventListener("resize", this.handleWindowResize);
  }

  toggleExpandPdfViewer() {
    this.setState({
      pdfViewerExpanded: !this.state.pdfViewerExpanded,
    });
  }

  handleDisplayPdf = (examSection) => {
    // Check for a pdf in the first section
    let pdfBytes = null;

    for (let i = 0; i < examSection.tabs.length; i++) {
      let tabContent = examSection.tabs[i].tabContent;
      for (let j = 0; j < tabContent.length; j++) {
        if (tabContent[j].pdfFile) {
          pdfBytes = tabContent[j].pdfBytes;
          break;
        }
      }
      if (pdfBytes) break;
    }

    if (pdfBytes) {
      this.displayPdfHandler(pdfBytes);
    }
  };

  handleWindowResize = () => {
    this.setState({ simulationWindowHeight: window.innerHeight });
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  componentWillUnmount() {
    this.stopTimer();
    window.removeEventListener("resize", this.handleWindowResize);
  }

  // fetchNextSection = async () => {
  //   this.setState({ fetchingNextSection: true });

  //   const nextSectionIndex = this.state.currentSection + 1;
  //   let body = {
  //     sectionId: this.props.selectedExamSections[nextSectionIndex],
  //     isTestComplete: !this.props.selectedExamSections[nextSectionIndex],
  //     examGuid: this.props.examGuid,
  //     custAnswers: Object.values(this.state.userAnswers),
  //     customerId: this.context.userData.CustomerId,
  //   };

  //   console.log(body);

  //   await fetch(`${this.context.route}/getsection.webapi`, {
  //     method: "POST",
  //     headers: {
  //       Token: this.context.userData.Token,
  //       "Content-Type": "text/plain",
  //     },
  //     body: JSON.stringify(body),
  //   })
  //     .then(async (response) => {
  //       if (response.ok) {
  //         return response.json();
  //       } else if (response.status === 401) {
  //         return this.context.displayAuthenticationError();
  //       } else {
  //         throw new Error(await response.text());
  //       }
  //     })
  //     .then(async (result) => {
  //       console.log(result);

  //       if (body.isTestComplete) {
  //         return setTimeout(() => {
  //           this.handleFinishExam();
  //         }, 1000);
  //       }
  //       this.appendSectionAnswersToAnswerSheet(
  //         result,
  //         false,
  //         this.state.userAnswers
  //       );
  //       this.handleDisplayPdf(result);
  //       this.setState(
  //         {
  //           sectionData: result,
  //           fetchingNextSection: false,
  //           currentSection: this.state.currentSection + 1,
  //           timerInSeconds: result.sectionTimeInSeconds,
  //           tabSelected: 0,
  //         },
  //         () => {
  //           if (this.contentWrapperRef != null) {
  //             this.contentWrapperRef.scrollTo(0, 0);
  //           }
  //           this.startTimer();
  //           setTimeout(() => {
  //             this.detectOverflowAndDisplayPopup();
  //           }, 3);
  //         }
  //       );
  //     })
  //     .catch((error) => {
  //       this.setState({ fetchingNextSection: false });
  //       console.log("error", error);
  //       // logFetchError(error, null, null, 'fetchLoginToken')
  //     });
  // };

  //added 12-18-2025
  fetchNextSection = async () => {
  this.setState({ fetchingNextSection: true });

  const nextSectionIndex = this.state.currentSection + 1;
  let body = {
    sectionId: this.props.selectedExamSections[nextSectionIndex],
    isTestComplete: !this.props.selectedExamSections[nextSectionIndex],
    examGuid: this.props.examGuid,
    custAnswers: Object.values(this.state.userAnswers),
    customerId: this.context.userData.CustomerId,
  };

  console.log(body);

  await fetch(`${this.context.route}/getsection.webapi`, {
    method: "POST",
    headers: {
      Token: this.context.userData.Token,
      "Content-Type": "text/plain",
    },
    body: JSON.stringify(body),
  })
    .then(async (response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status === 401) {
        return this.context.displayAuthenticationError();
      } else {
        throw new Error(await response.text());
      }
    })
    .then(async (result) => {
      console.log(result);

      if (body.isTestComplete) {
        return setTimeout(() => {
          this.handleFinishExam();
        }, 1000);
      }
      
      // Get new userAnswers BEFORE setState to avoid race condition
      const newUserAnswers = getAnswerSheet(result, this.state.userAnswers);
      
      this.handleDisplayPdf(result);
      this.setState(
        {
          sectionData: result,
          fetchingNextSection: false,
          currentSection: this.state.currentSection + 1,
          timerInSeconds: result.sectionTimeInSeconds,
          tabSelected: 0,
          userAnswers: newUserAnswers,  // Update userAnswers atomically with sectionData
        },
        () => {
          if (this.contentWrapperRef != null) {
            this.contentWrapperRef.scrollTo(0, 0);
          }
          this.startTimer();
          setTimeout(() => {
            this.detectOverflowAndDisplayPopup();
          }, 3);
        }
      );
    })
    .catch((error) => {
      this.setState({ fetchingNextSection: false });
      console.log("error", error);
      // logFetchError(error, null, null, 'fetchLoginToken')
    });
};

  detectOverflowAndDisplayPopup = () => {
    if (this.contentWrapperRef != null) {
      if (
        this.contentWrapperRef.offsetHeight <
        this.contentWrapperRef.scrollHeight
      )
        this.setState({ simulationBodyOverflowDetected: true });
      else this.setState({ simulationBodyOverflowDetected: false });
    }
  };

  appendSectionAnswersToAnswerSheet = (
    sectionData,
    componentMounting = false,
    initialAnswers
  ) => {
    const userAnswers = getAnswerSheet(sectionData, initialAnswers);
    if (userAnswers !== null) {
      if (componentMounting) {
        this.state.userAnswers = userAnswers;
      } else {
        this.setState({ userAnswers });
      }
    }
  };

  startTimer = (speakingSkip = false) => {
    /*if (
      this.state.sectionData.sectionCategory.includes("Speaking") &&
      !speakingSkip
    ) {
      return;
    }*/
    this.sectionTimer = setInterval(() => {
      this.setState({ timerInSeconds: this.state.timerInSeconds - 1 }, () => {
        if (this.state.timerInSeconds === 0) {
          this.advanceToNextSection(false);
          this.handleOutOfTime();
        }
      });
    }, 1000);
  };

  handleOutOfTime = () => {
    this.setState({ displayRanOutOfTimePopup: true });
  };

  stopTimer = () => {
    clearInterval(this.sectionTimer);
    this.sectionTimer = null;
  };

  handleChangeQuestionButtons = (buttonClicked) => {
    // If the next button is clicked, go to the next question
    if (buttonClicked === "next") this.handleNextButton();
    // If the back button is clicked, go to the previous question
    else if (buttonClicked === "back") this.handleBackButton();
  };

  changeTab = (newTab) => {
    this.setState({ tabSelected: newTab });
  };

  saveAudioFile = (questionId, audioFile) => {
    let userAnswers = this.state.userAnswers;
    userAnswers[questionId].mp3File = audioFile;
    this.setState({ userAnswers });
  };

  sendAudioToDatabaseServer = async (questionId) => {
    const formData = new FormData();
    formData.append("file", this.state.userAnswers[questionId].mp3File);
    this.setState({ displayUploadingFilePopup: true, uploadProgress: 0 });
    let file = this.state.userAnswers[questionId].mp3File;
    if (!file) return true;
    let currentMilliseconds = file.lastModified;
    currentMilliseconds = currentMilliseconds - (currentMilliseconds % 1000);

    let secondsTotal = 0;
    for (let i = 0; i < this.props.examGuid.length; i++) {
      if (this.props.examGuid[i] === "-") {
        continue;
      } else {
        secondsTotal += parseInt(this.props.examGuid[i], 16);
      }
    }

    currentMilliseconds += secondsTotal;

    let requestData = {
      method: "POST",
      url: `${this.context.route}/senduseraudio.webapi`,
      headers: {
        "Content-Type": "multipart/form-data",
        Token: this.context.userData.Token,
        ExamGuid: this.props.examGuid,
        LastModified: currentMilliseconds,
      },
      data: formData,
      onUploadProgress: (p) => {
        this.setState({ uploadProgress: p.progress });
        if (p.progress === 1) {
          this.setState({ displayUploadingFilePopup: false });
        }
      },
    };

    let audioUploadRequest;

    try {
      audioUploadRequest = await axios.request(requestData);
    } catch (error) {
      this.setState({ displayUploadingFilePopup: false });
      return false;
    }
    this.setState({ displayUploadingFilePopup: false });
    return true;
  };

  advanceToNextSection = async (displayPopup) => {
    if (displayPopup) return this.setState({ displayFinishSectionPopup: true });

    for (let i = 0; i < this.state.sectionData.tabs.length; ++i) {
      for (
        let j = 0;
        j < this.state.sectionData.tabs[i].tabContent.length;
        ++j
      ) {
        let tabContent = this.state.sectionData.tabs[i].tabContent[j];
        if (tabContent.type === "writing") {
          if (this.state.userAnswers[tabContent.questionId].answer === "") {
            this.setState({ fetchingNextSection: false });
            return window.alert(
              "You cannot submit a blank answer for a writing question. Please provide an answer in the text box."
            );
          }
        } else if (tabContent.type === "speaking") {
          if (this.context.chatHistory.length === 0) {
            return window.alert("You cannot submit an empty speaking exam.");
          }
        }
      }
    }

    this.setState({ displayPDFViewer: false, pdfDocked: false });

    this.stopTimer();
    await this.fetchNextSection();
  };

  handleFinishExam = () => {
    this.context.showCaseGradeAfterCompletion();
  };

  handleNextButton = () => {
    // If the current tab is not the last tab in the current section, go to the next tab
    if (this.state.tabSelected < this.state.sectionData.tabs.length - 1)
      this.changeTab(this.state.tabSelected + 1);
    // If the current tab is the last tab in the current section, go to the next section
    else this.advanceToNextSection(true);
  };

  handleBackButton = () => {
    if (this.state.tabSelected > 0)
      this.setState({ tabSelected: this.state.tabSelected - 1 });
  };

  endBreak = () => {
    this.setState({ onBreak: false });
  };

  updateInputAnswer = (event, questionId) => {
    let userAnswers = this.state.userAnswers;
    userAnswers[questionId].answer = event.target.value;
    this.setState({ userAnswers });
  };

  handleMultipleChoiceSelection = (questionId, answerId) => {
    let userAnswers = this.state.userAnswers;
    userAnswers[questionId].answerId = answerId;
    this.setState({ userAnswers });
  };

  closeFinishSectionPopup = () => {
    this.setState({ displayFinishSectionPopup: false });
  };

  finishSection = () => {
    this.setState({ displayFinishSectionPopup: false }, () => {
      this.advanceToNextSection(false);
    });
  };

  closePDFViewer = () => {
    this.setState({ displayPDFViewer: false });
  };

  displayPdfHandler = (pdfBase64) => {
    if (pdfBase64.startsWith("data:application/pdf;base64,")) {
      this.setState({ displayPDFViewer: true, pdfToDisplay: pdfBase64 });
      return;
    }

    // Remove double quotes from the base64 string
    pdfBase64 = pdfBase64.replace(/"/g, "");
    let pdf = "data:application/pdf;base64," + pdfBase64;
    this.setState({ displayPDFViewer: true, pdfToDisplay: pdf });
  };

  updateWritingAnswer = (questionId, value) => {
    let userAnswers = this.state.userAnswers;
    userAnswers[questionId].answer = value;
    this.setState({ userAnswers });
  };

  displayExitExamPopup = () => {
    this.setState({ displayExitExamPopup: true });
  };

  render() {
    const selectedTab = this.state.sectionData.tabs[this.state.currentTab];

    return (
      <div
        className="simulationWrapper"
        style={{
          gridTemplateColumns: this.state.pdfDocked ? "1fr 1fr" : "1fr",
          display: this.state.pdfDocked ? "grid" : "block",
        }}
      >
        <div
          className="simulationPageContainer"
          style={{ height: this.state.simulationWindowHeight }}
        >
          <Header
            timeLeft={this.state.timerInSeconds}
            sectionTitle={this.state.sectionData.sectionTitle}
            finishSection={() => this.advanceToNextSection(true)}
            currentSection={this.state.currentSection}
            totalSections={this.props.selectedExamSections.length}
            exitExam={this.displayExitExamPopup}
          />{" "}
          {this.state.displayPDFViewer &&
            this.state.isMobile && ( //this WILL display on mobile
              <NewPdfViewer
                pdfFile={this.state.pdfToDisplay}
                onClose={this.closePDFViewer}
                pdfDocked={this.state.pdfDocked}
                handlePdfDock={(newState) =>
                  this.setState({ pdfDocked: newState })
                }
                isMobile={this.state.isMobile}
                pdfViewerExpanded={this.state.pdfViewerExpanded}
                toggleExpandPdfViewer={this.toggleExpandPdfViewer}
              />
            )}
          {((!this.state.displayPDFViewer && this.state.isMobile) ||
            !this.state.isMobile ||
            (this.state.isMobile &&
              this.state.displayPDFViewer &&
              !this.state.pdfViewerExpanded)) && (
            <div className="simulationBodyWrapper">
              <TabNavigation
                tabs={this.state.sectionData.tabs}
                changeTab={this.changeTab}
                tabSelected={this.state.tabSelected}
              />
              <div
                className="simulationContentWrapper"
                onScroll={() =>
                  this.setState({ simulationBodyOverflowDetected: false })
                }
                ref={(ref) => (this.contentWrapperRef = ref)}
              >
                {selectedTab.tabContent.some(
                  (content) => content.type === "speaking"
                ) ? (
                  <SpeakingSection
                    examGuid={this.props.examGuid}
                    ExamAttemptId={this.state.sectionData.ExamAttemptId}
                    handleSkipSection={() => this.handleNextButton()}
                  />
                ) : (
                  selectedTab.tabContent.map((content, index) => (
                    <ContentInterfaceElement
                      key={`simulationContent${index}-${this.state.sectionData.sectionId}`}
                      content={content}
                      componentIndex={index}
                      sectionData={this.state.sectionData}
                      handleMultipleChoiceSelection={
                        this.handleMultipleChoiceSelection
                      }
                      userAnswers={this.state.userAnswers}
                      displayPdfHandler={this.displayPdfHandler}
                      updateInputAnswer={this.updateInputAnswer}
                      selectedAccent={this.state.selectedAccent}
                      detectOverflowAndDisplayPopup={
                        this.detectOverflowAndDisplayPopup
                      }
                      updateWritingAnswer={this.updateWritingAnswer}
                      examGuid={this.props.examGuid}
                    />
                  ))
                )}
                {this.state.simulationBodyOverflowDetected && (
                  <div
                    className="simulationBodyOverflowPopupContainer"
                    onClick={() =>
                      this.setState({ simulationBodyOverflowDetected: false })
                    }
                  >
                    <p>This page requires scrolling</p>
                    <FontAwesomeIcon
                      icon={faCircleXmark}
                      className="simulationBodyOverflowPopupIcon"
                    />
                  </div>
                )}
              </div>
            </div>
          )}
          <Footer
            tabSelected={this.state.tabSelected}
            onChangeQuestion={this.handleChangeQuestionButtons}
            maxNavigationValue={this.state.sectionData.tabs.length - 1}
          />
          {this.state.onBreak && <TestBreakPopup endBreak={this.endBreak} />}
          {this.state.displayRanOutOfTimePopup && (
            <OutOfTimePopup
              closePopup={() =>
                this.setState({ displayRanOutOfTimePopup: false })
              }
            />
          )}
          {this.state.displayFinishSectionPopup && (
            <FinishSectionPopup
              onClose={this.closeFinishSectionPopup}
              onConfirm={this.finishSection}
            />
          )}
          {this.state.displayProcessingAudioPopup && <ProcessingAudioPopup />}
          {this.state.fetchingNextSection && <FetchingNextSectionPopup />}
          {this.state.displayUploadingFilePopup && (
            <UploadingFilePopup uploadProgress={this.state.uploadProgress} />
          )}
          {this.state.displayExitExamPopup && (
            <ExitExamPopup
              onClose={() => this.setState({ displayExitExamPopup: false })}
              onConfirm={this.props.exitExam}
            />
          )}
        </div>
        {this.state.displayPDFViewer &&
          !this.state.isMobile && ( //this won't display on mobile this way
            <NewPdfViewer
              pdfFile={this.state.pdfToDisplay}
              onClose={this.closePDFViewer}
              pdfDocked={this.state.pdfDocked}
              handlePdfDock={(newState) =>
                this.setState({ pdfDocked: newState })
              }
              isMobile={this.state.isMobile}
              pdfViewerExpanded={true}
              toggleExpandPdfViewer={this.toggleExpandPdfViewer}
            />
          )}
      </div>
    );
  }
}
